/* eslint-disable @retail/i18n-checker/require-translate */
import { lazy } from 'react';
import reactContainerFactory from '@/components/react-container/reactContainerFactory';

// Skill Config Rule 公共面包屑配置
const skillConfigRuleBaseNavList = [
  {
    routeName: 'ruleCenter',
    title: 'Rule Center',
  },
  {
    routeName: 'ruleCenter.skillManagementRule',
    title: 'Skill Management Rule',
  },
  {
    routeName: 'ruleCenter.skillManagementRule.skillConfigRule',
    title: 'Skill Config Rule',
  },
];
const skillConfigRuleForOperatorBaseNavList = [
  ...skillConfigRuleBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.skillConfigRule',
    title: 'For Operator',
  },
];
const skillConfigRuleSalesOutboundBaseNavList = [
  ...skillConfigRuleForOperatorBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound',
    title: 'Sales Outbound',
  },
];
const skillConfigRuleMoveTransferBaseNavList = [
  ...skillConfigRuleForOperatorBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer',
    title: 'Move Transfer',
  },
];
const skillConfigRuleCycleCountBaseNavList = [
  ...skillConfigRuleForOperatorBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.skillConfigRule.cycleCount',
    title: 'Cycle Count',
  },
];
const skillConfigRuleRackTransferBaseNavList = [
  ...skillConfigRuleForOperatorBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer',
    title: 'Rack Transfer',
  },
];
const skillConfigRuleInboundBaseNavList = [
  ...skillConfigRuleForOperatorBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.skillConfigRule.inbound',
    title: 'Purchase Inbound',
  },
];
const skillConfigRuleReplenishmentReturnBaseNavList = [
  ...skillConfigRuleForOperatorBaseNavList,
  {
    routeName:
      'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn',
    title: 'Replenishment/Reverse',
  },
];
const skillConfigRuleRearrangementBaseNavList = [
  ...skillConfigRuleForOperatorBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.skillConfigRule.rearrangement',
    title: 'Rearrangement',
  },
];
const skillConfigRuleForFLDriverBaseNavList = [
  ...skillConfigRuleBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.skillConfigRule.forFLDriver',
    title: 'For FL Driver',
  },
];
const skillConfigRulePutdownBaseNavList = [
  ...skillConfigRuleForFLDriverBaseNavList,
  {
    routeName:
      'ruleCenter.skillManagementRule.skillConfigRule.forFLDriver.putdown',
    title: 'Putdown',
  },
];

// Operator Skill 公共面包屑配置
const operatorSkillBaseNavList = [
  {
    routeName: 'ruleCenter',
    title: 'Rule Center',
  },
  {
    routeName: 'ruleCenter.skillManagementRule',
    title: 'Skill Management Rule',
  },
  {
    routeName: 'ruleCenter.skillmanagementrule.operatorskill',
    title: 'Operator Skill',
  },
];
const operatorSkillForOperatorBaseNavList = [
  ...operatorSkillBaseNavList,
  {
    routeName: 'ruleCenter.skillmanagementrule.operatorskill',
    title: 'For Operator',
  },
];
const operatorSkillSalesOutboundBaseNavList = [
  ...operatorSkillForOperatorBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound',
    title: 'Sales Outbound',
  },
];
const operatorSkillMoveTransferBaseNavList = [
  ...operatorSkillForOperatorBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer',
    title: 'Move Transfer',
  },
];
const operatorSkillCycleCountBaseNavList = [
  ...operatorSkillForOperatorBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.operatorSkill.cycleCount',
    title: 'Cycle Count',
  },
];
const operatorSkillRackTransferBaseNavList = [
  ...operatorSkillForOperatorBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.operatorSkill.rackTransfer',
    title: 'Rack Transfer',
  },
];
const operatorSkillInboundBaseNavList = [
  ...operatorSkillForOperatorBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.operatorSkill.inbound',
    title: 'Purchase Inbound',
  },
];
const operatorSkillReplenishmentReturnBaseNavList = [
  ...operatorSkillForOperatorBaseNavList,
  {
    routeName:
      'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn',
    title: 'Replenishment/Reverse',
  },
];
const operatorSkillRearrangementBaseNavList = [
  ...operatorSkillForOperatorBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.operatorSkill.rearrangement',
    title: 'Rearrangement',
  },
];
const operatorSkillForFLDriverBaseNavList = [
  ...operatorSkillBaseNavList,
  {
    routeName: 'ruleCenter.skillManagementRule.operatorSkill.forFLDriver',
    title: 'For FL Driver',
  },
];
const operatorSkillPutdownBaseNavList = [
  ...operatorSkillForFLDriverBaseNavList,
  {
    routeName:
      'ruleCenter.skillManagementRule.operatorSkill.forFLDriver.putdown',
    title: 'Putdown',
  },
];

export default {
  path: 'skillManagementRule',
  name: 'ruleCenter.skillManagementRule',
  meta: {
    title: 'Skill Management Rule',
  },
  component: () => import('@/views/layout/subPage.vue'),
  redirect:
    '/rulecenter/skillManagementRule/skillConfigRule/salesOutbound/picking',
  children: [
    {
      path: 'skillConfigRule',
      name: 'ruleCenter.skillManagementRule.skillConfigRule',
      meta: {
        title: 'Skill Config Rule',
      },
      redirect:
        '/rulecenter/skillManagementRule/skillConfigRule/salesOutbound/picking',
      component: () => import('@/views/layout/subPage.vue'),
      children: [
        {
          path: 'salesOutbound',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound',
          meta: {
            title: 'Sales Outbound',
            menuHide: true,
          },
          component: () => import('@/views/layout/subPage.vue'),
          redirect:
            '/rulecenter/skillManagementRule/skillConfigRule/salesOutbound/picking',
        },
        {
          path: 'salesOutbound/picking',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.picking',
          meta: {
            title: 'Picking',
            menuHide: true,
            navList: skillConfigRuleSalesOutboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'salesOutbound/picking/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.picking.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...skillConfigRuleSalesOutboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.picking',
                title: 'Picking',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/skill-config-rule/components/picking-rule/create.vue'
            ),
        },
        {
          path: 'salesOutbound/picking/edit/:rule_id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.picking.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleSalesOutboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.picking',
                title: 'Picking',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/skill-config-rule/components/picking-rule/create.vue'
            ),
        },
        {
          path: 'salesOutbound/sorting',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.sorting',
          meta: {
            title: 'Sorting',
            menuHide: true,
            navList: skillConfigRuleSalesOutboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'salesOutbound/sorting/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.sorting.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...skillConfigRuleSalesOutboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.sorting',
                title: 'Sorting',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/skill-config-rule/components/sorting-rule/create.vue'
            ),
        },
        {
          path: 'salesOutbound/sorting/edit/:rule_id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.sorting.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleSalesOutboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.sorting',
                title: 'Sorting',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/skill-config-rule/components/sorting-rule/create.vue'
            ),
        },
        {
          path: 'salesOutbound/checking',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.checking',
          meta: {
            title: 'Checking',
            menuHide: true,
            navList: skillConfigRuleSalesOutboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'salesOutbound/checking/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.checking.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...skillConfigRuleSalesOutboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.checking',
                title: 'Checking',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/skill-config-rule/components/checking-rule/create.vue'
            ),
        },
        {
          path: 'salesOutbound/checking/edit/:rule_id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.checking.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleSalesOutboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.salesOutbound.checking',
                title: 'Checking',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/skill-config-rule/components/checking-rule/create.vue'
            ),
        },
        {
          path: 'moveTransfer',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer',
          meta: {
            title: 'Picking',
            menuHide: true,
          },
          redirect:
            '/rulecenter/skillManagementRule/skillConfigRule/moveTransfer/picking',
        },
        {
          path: 'moveTransfer/picking',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.picking',
          meta: {
            title: 'Picking',
            menuHide: true,
            navList: skillConfigRuleMoveTransferBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'moveTransfer/picking/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.picking.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...skillConfigRuleMoveTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.picking',
                title: 'Picking',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/skill-config-rule/components/picking-rule/mt-create.vue'
            ),
        },
        {
          path: 'moveTransfer/picking/edit/:rule_id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.picking.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleMoveTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.picking',
                title: 'Picking',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/skill-config-rule/components/picking-rule/mt-create.vue'
            ),
        },

        {
          path: 'moveTransfer/putaway',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.putaway',
          meta: {
            title: 'Putaway',
            menuHide: true,
            navList: skillConfigRuleMoveTransferBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'moveTransfer/putaway/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.putaway.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...skillConfigRuleMoveTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.putaway',
                title: 'Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.putaway.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/move-transfer/putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'moveTransfer/putaway/edit/:id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.putaway.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleMoveTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.putaway',
                title: 'Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.putaway.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/move-transfer/putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'moveTransfer/checking',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.checking',
          meta: {
            title: 'Checking',
            menuHide: true,
            navList: skillConfigRuleMoveTransferBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'moveTransfer/checking/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.checking.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...skillConfigRuleMoveTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.checking',
                title: 'Checking',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.checking.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/move-transfer/checking/edit'
                  )
              ),
          },
        },
        {
          path: 'moveTransfer/checking/edit/:id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.checking.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleMoveTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.checking',
                title: 'Checking',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.moveTransfer.checking.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/move-transfer/checking/edit'
                  )
              ),
          },
        },
        {
          path: 'cycleCount',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.cycleCount',
          meta: {
            title: 'Cycle Count',
            menuHide: true,
          },
          component: () => import('@/views/layout/subPage.vue'),
          redirect:
            '/rulecenter/skillManagementRule/skillConfigRule/cycleCount/cycleCount',
          children: [
            {
              path: 'cycleCount',
              name: 'ruleCenter.skillManagementRule.skillConfigRule.cycleCount.cycleCount',
              meta: {
                title: 'Cycle Count',
                menuHide: true,
                navList: skillConfigRuleCycleCountBaseNavList,
              },
              component: () =>
                import('@/views/rule-center/skill-config-rule/tabs.vue'),
            },
            {
              path: 'cycleCountPool',
              name: 'ruleCenter.skillManagementRule.skillConfigRule.cycleCount.cycleCountPool',
              meta: {
                title: 'Cycle Count Pool',
                menuHide: true,
                navList: skillConfigRuleCycleCountBaseNavList,
              },
              component: () =>
                import('@/views/rule-center/skill-config-rule/tabs.vue'),
            },
          ],
        },
        {
          path: 'cycleCount/cycleCountPool/:mode(create|edit|view)/:rule_id?',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.cycleCount.cycleCountPool.detail',
          meta: {
            title: 'Detail',
            menuHide: true,
            navList: [
              ...skillConfigRuleCycleCountBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.cycleCount.cycleCountPool',
                title: 'Cycle Count Pool',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.cycleCount.cycleCountPool.detail',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/cycle-count/cycle-count-pool/detail'
                  )
              ),
          },
        },
        {
          path: 'cycleCount/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.cycleCount.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...skillConfigRuleCycleCountBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.cycleCount.cycleCount',
                title: 'Cycle Count',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.cycleCount.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/cycle-count/cycleCountEdit'
                  )
              ),
          },
        },
        {
          path: 'cycleCount/edit/:id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.cycleCount.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleCycleCountBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.cycleCount.cycleCount',
                title: 'Cycle Count',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.cycleCount.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/cycle-count/cycleCountEdit'
                  )
              ),
          },
        },
        {
          path: 'rackTransfer',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer',
          meta: {
            title: 'RT Putaway',
            menuHide: true,
          },
          redirect:
            '/rulecenter/skillManagementRule/skillConfigRule/rackTransfer/rtPutaway',
        },
        {
          path: 'rackTransfer/rtPutaway',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer.rtPutaway',
          meta: {
            title: 'RT Putaway',
            menuHide: true,
            navList: skillConfigRuleRackTransferBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'rackTransfer/rtPutaway/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer.rtPutaway.create',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleRackTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer.rtPutaway',
                title: 'RT Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer.rtPutaway.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/rack-transfer/rt-putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'rackTransfer/rtPutaway/edit/:id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer.rtPutaway.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleRackTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer.rtPutaway',
                title: 'RT Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer.rtPutaway.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/rack-transfer/rt-putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'rackTransfer/rackTransfer',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer.rackTransfer',
          meta: {
            title: 'Rack transfer',
            menuHide: true,
            navList: skillConfigRuleRackTransferBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'rackTransfer/rackTransfer/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer.rackTransfer.create',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleRackTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer.rackTransfer',
                title: 'Rack Transfer',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer.rackTransfer.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/rack-transfer/rack-transfer/rackTransferEdit'
                  )
              ),
          },
        },
        {
          path: 'rackTransfer/rackTransfer/edit/:id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer.rackTransfer.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleRackTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer.rackTransfer',
                title: 'Rack Transfer',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.rackTransfer.rackTransfer.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/rack-transfer/rack-transfer/rackTransferEdit'
                  )
              ),
          },
        },
        {
          path: 'inbound',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound',
          meta: {
            title: 'Purchase Inbound',
            menuHide: true,
          },
          redirect:
            '/rulecenter/skillManagementRule/skillConfigRule/inbound/putaway',
        },
        {
          path: 'inbound/putaway',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.putaway',
          meta: {
            title: 'Putaway',
            menuHide: true,
            navList: skillConfigRuleInboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'inbound/putaway/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.putaway.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...skillConfigRuleInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.inbound.putaway',
                title: 'Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.putaway.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/inbound/putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'inbound/putaway/edit/:id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.putaway.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.inbound.putaway',
                title: 'Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.putaway.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/inbound/putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'inbound/arriving',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.arriving',
          meta: {
            title: 'Arriving',
            menuHide: true,
            navList: skillConfigRuleInboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'inbound/arriving/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.arriving.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...skillConfigRuleInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.inbound.arriving',
                title: 'Arriving',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.arriving.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/inbound/arriving/edit'
                  )
              ),
          },
        },
        {
          path: 'inbound/arriving/edit/:id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.arriving.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.inbound.arriving',
                title: 'Arriving',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.arriving.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/inbound/arriving/edit'
                  )
              ),
          },
        },
        {
          path: 'inbound/boxing',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.boxing',
          meta: {
            title: 'Boxing',
            menuHide: true,
            navList: skillConfigRuleInboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'inbound/boxing/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.boxing.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...skillConfigRuleInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.inbound.boxing',
                title: 'Boxing',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.boxing.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/inbound/boxing/edit'
                  )
              ),
          },
        },
        {
          path: 'inbound/boxing/edit/:id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.boxing.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.inbound.boxing',
                title: 'Boxing',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.boxing.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/inbound/boxing/edit'
                  )
              ),
          },
        },

        {
          path: 'inbound/crossDockSorting',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.crossDockSorting',
          meta: {
            title: 'Cross Dock Sorting',
            menuHide: true,
            navList: skillConfigRuleInboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'inbound/crossDockSorting/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.crossDockSorting.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...skillConfigRuleInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.inbound.crossDockSorting',
                title: 'Cross Dock Sorting',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.boxing.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/inbound/cross-dock-sorting/edit'
                  )
              ),
          },
        },
        {
          path: 'inbound/crossDockSorting/edit/:id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.crossDockSorting.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.inbound.crossDockSorting',
                title: 'Cross Dock Sorting',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.inbound.crossDockSorting.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/inbound/cross-dock-sorting/edit'
                  )
              ),
          },
        },

        {
          path: 'replenishmentReturn',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn',
          meta: {
            title: 'RR Putaway',
            menuHide: true,
          },
          redirect:
            '/rulecenter/skillManagementRule/skillConfigRule/replenishmentReturn/rrPutaway',
        },
        {
          path: 'replenishmentReturn/rrPutaway',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn.rrPutaway',
          meta: {
            title: 'RR Putaway',
            menuHide: true,
            navList: skillConfigRuleReplenishmentReturnBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'replenishmentReturn/rrPutaway/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn.rrPutaway.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...skillConfigRuleReplenishmentReturnBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn.rrPutaway',
                title: 'RR Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn.rrPutaway.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/replenishment-return/rr-putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'replenishmentReturn/rrPutaway/edit/:id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn.rrPutaway.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleReplenishmentReturnBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn.rrPutaway',
                title: 'RR Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn.rrPutaway.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/replenishment-return/rr-putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'replenishmentReturn/replenishmentReturn',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn.replenishmentReturn',
          meta: {
            title: 'Replenishment/Reverse',
            menuHide: true,
            navList: skillConfigRuleReplenishmentReturnBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'replenishmentReturn/replenishmentReturn/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn.replenishmentReturn.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...skillConfigRuleReplenishmentReturnBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn.replenishmentReturn',
                title: 'Replenishment/Reverse',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn.replenishmentReturn.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/replenishment-return/replenishment-return/edit'
                  )
              ),
          },
        },
        {
          path: 'replenishmentReturn/replenishmentReturn/edit/:id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn.replenishmentReturn.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleReplenishmentReturnBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn.replenishmentReturn',
                title: 'Replenishment/Reverse',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.replenishmentReturn.replenishmentReturn.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/replenishment-return/replenishment-return/edit'
                  )
              ),
          },
        },
        {
          path: 'rearrangement',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.rearrangement',
          meta: {
            title: 'Rearrangement',
            menuHide: true,
          },
          redirect:
            '/rulecenter/skillManagementRule/skillConfigRule/rearrangement/picking',
        },
        {
          path: 'rearrangement/picking',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.rearrangement.picking',
          meta: {
            title: 'Picking',
            menuHide: true,
            navList: skillConfigRuleRearrangementBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
        },
        {
          path: 'rearrangement/picking/create',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.rearrangement.picking.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...skillConfigRuleRearrangementBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.rearrangement.picking',
                title: 'Picking',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.rearrangement.picking.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/rearrangement/picking/edit'
                  )
              ),
          },
        },
        {
          path: 'rearrangement/picking/edit/:id',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.rearrangement.picking.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...skillConfigRuleRearrangementBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.skillConfigRule.rearrangement.picking',
                title: 'Picking',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.rearrangement.picking.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/rearrangement/picking/edit'
                  )
              ),
          },
        },
        {
          path: 'forFLDriver',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.forFLDriver',
          meta: {
            title: 'For FL Driver',
            menuHide: true,
          },
          component: () =>
            import('@/views/rule-center/skill-config-rule/tabs.vue'),
          redirect:
            '/rulecenter/skillManagementRule/skillConfigRule/forFLDriver/putdown',
          children: [
            {
              path: 'putdown',
              name: 'ruleCenter.skillManagementRule.skillConfigRule.forFLDriver.putdown',
              meta: {
                title: 'Putdown',
                menuHide: true,
              },
            },
          ],
        },
        {
          path: 'putdown/detail/:mode(create|edit)/:rule_id?',
          name: 'ruleCenter.skillManagementRule.skillConfigRule.forFLDriver.putdown.detail',
          meta: {
            title: 'Putdown Detail',
            menuHide: true,
            navList: skillConfigRulePutdownBaseNavList,
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.skillConfigRule.forFLDriver.putdown.detail',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/skill-config-rule/for-fl-driver/putdown/form'
                  )
              ),
          },
        },
      ],
    },
    {
      path: 'operatorSkill',
      name: 'ruleCenter.skillmanagementrule.operatorskill',
      meta: {
        title: 'Operator Skill',
      },
      redirect: '/rulecenter/skillManagementRule/operatorSkill/salesOutbound',
      component: () => import('@/views/layout/subPage.vue'),
      children: [
        {
          path: 'salesOutbound',
          name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound',
          meta: {
            title: 'Sales Outbound',
            menuHide: true,
          },
          component: () => import('@/views/layout/subPage.vue'),
          redirect:
            '/rulecenter/skillManagementRule/operatorSkill/salesOutbound/picking',
        },
        {
          path: 'salesOutbound/flowPicking',
          name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.flowPicking',
          meta: {
            title: 'Flow Picking',
            menuHide: true,
            navList: operatorSkillSalesOutboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'salesOutbound/flowPicking/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.flowPicking.create',
          meta: {
            title: 'Flow Picking',
            menuHide: true,
            navList: [
              ...operatorSkillSalesOutboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.flowPicking',
                title: 'Flow Picking',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.flowPicking.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/sales-outbound/flow-picking/edit'
                  )
              ),
          },
        },
        {
          path: 'salesOutbound/flowPicking/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.flowPicking.edit',
          meta: {
            title: 'Flow Picking',
            menuHide: true,
            navList: [
              ...operatorSkillSalesOutboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.flowPicking',
                title: 'Flow Picking',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.flowPicking.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/sales-outbound/flow-picking/edit'
                  )
              ),
          },
        },
        {
          path: 'salesOutbound/picking',
          name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.picking',
          meta: {
            title: 'Picking',
            menuHide: true,
            navList: operatorSkillSalesOutboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'salesOutbound/picking/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.picking.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillSalesOutboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.picking',
                title: 'Picking',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/operator-skill/components/picking-skills/create.vue'
            ),
        },
        {
          path: 'pickingSkills/edit/:user_id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.picking.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillSalesOutboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.picking',
                title: 'Picking',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/operator-skill/components/picking-skills/create.vue'
            ),
        },
        {
          path: 'salesOutbound/sorting',
          name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.sorting',
          meta: {
            title: 'Sorting',
            menuHide: true,
            navList: operatorSkillSalesOutboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'salesOutbound/sorting/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.sorting.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillSalesOutboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.sorting',
                title: 'Sorting',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/operator-skill/components/sorting-skill-management/create.vue'
            ),
        },
        {
          path: 'salesOutbound/sorting/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.sorting.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillSalesOutboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.sorting',
                title: 'Sorting',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/operator-skill/components/sorting-skill-management/create.vue'
            ),
        },
        {
          path: 'salesOutbound/checking',
          name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.checking',
          meta: {
            title: 'Checking',
            menuHide: true,
            navList: operatorSkillSalesOutboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'salesOutbound/checking/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.checking.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillSalesOutboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.checking',
                title: 'Checking',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/operator-skill/components/checking-skill-management/create.vue'
            ),
        },
        {
          path: 'salesOutbound/checking/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.checking.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillSalesOutboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.salesOutbound.checking',
                title: 'Checking',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/operator-skill/components/checking-skill-management/create.vue'
            ),
        },
        {
          path: 'moveTransfer',
          name: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer',
          meta: {
            title: 'Picking',
            menuHide: true,
          },
          redirect:
            '/rulecenter/skillManagementRule/operatorSkill/moveTransfer/picking',
        },
        {
          path: 'moveTransfer/picking',
          name: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.picking',
          meta: {
            title: 'Picking',
            menuHide: true,
            navList: operatorSkillMoveTransferBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'moveTransfer/picking/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.picking.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillMoveTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.picking',
                title: 'Picking',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/operator-skill/components/picking-skills/create-mt-outbound.vue'
            ),
        },
        {
          path: 'moveTransfer/picking/edit/:user_id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.picking.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillMoveTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.picking',
                title: 'Picking',
              },
            ],
          },
          component: () =>
            import(
              '@/views/rule-center/operator-skill/components/picking-skills/create-mt-outbound.vue'
            ),
        },
        {
          path: 'moveTransfer/putaway',
          name: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.putaway',
          meta: {
            title: 'Putaway',
            menuHide: true,
            navList: operatorSkillMoveTransferBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'moveTransfer/putaway/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.putaway.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillMoveTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.putaway',
                title: 'Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.putaway.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/move-transfer/putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'moveTransfer/putaway/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.putaway.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillMoveTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.putaway',
                title: 'Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.putaway.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/move-transfer/putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'moveTransfer/checking',
          name: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.checking',
          meta: {
            title: 'Checking',
            menuHide: true,
            navList: operatorSkillMoveTransferBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'moveTransfer/checking/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.checking.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillMoveTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.checking',
                title: 'Checking',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.checking.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/move-transfer/checking/edit'
                  )
              ),
          },
        },
        {
          path: 'moveTransfer/checking/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.checking.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillMoveTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.checking',
                title: 'Checking',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.moveTransfer.checking.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/move-transfer/checking/edit'
                  )
              ),
          },
        },
        {
          path: 'cycleCount',
          name: 'ruleCenter.skillManagementRule.operatorSkill.cycleCount',
          meta: {
            title: 'Cycle Count',
            menuHide: true,
          },
          component: () => import('@/views/layout/subPage.vue'),
          redirect:
            '/rulecenter/skillManagementRule/operatorSkill/cycleCount/cycleCount',
          children: [
            {
              path: 'cycleCount',
              name: 'ruleCenter.skillManagementRule.operatorSkill.cycleCount.cycleCount',
              meta: {
                title: 'Cycle Count',
                menuHide: true,
                navList: operatorSkillCycleCountBaseNavList,
              },
              component: () =>
                import('@/views/rule-center/operator-skill/tabs.vue'),
            },
            {
              path: 'cycleCountPool',
              name: 'ruleCenter.skillManagementRule.operatorSkill.cycleCount.cycleCountPool',
              meta: {
                title: 'Cycle Count Pool',
                menuHide: true,
                navList: operatorSkillCycleCountBaseNavList,
              },
              component: () =>
                import('@/views/rule-center/operator-skill/tabs.vue'),
            },
          ],
        },
        {
          path: 'cycleCount/cycleCountPool/:mode(create|edit)/:id?',
          name: 'ruleCenter.skillManagementRule.operatorSkill.cycleCount.cycleCountPool.detail',
          meta: {
            title: 'Detail',
            menuHide: true,
            navList: [
              ...operatorSkillCycleCountBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.cycleCount.cycleCountPool',
                title: 'Cycle Count Pool',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.cycleCount.cycleCountPool.detail',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/cycle-count/cycle-count-pool/detail'
                  )
              ),
          },
        },
        {
          path: 'cycleCount/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.cycleCount.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillCycleCountBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.cycleCount.cycleCount',
                title: 'Cycle Count',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.cycleCount.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/cycle-count/cycleCountEdit'
                  )
              ),
          },
        },
        {
          path: 'cycleCount/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.cycleCount.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillCycleCountBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.cycleCount.cycleCount',
                title: 'Cycle Count',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.cycleCount',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/cycle-count/cycleCountEdit'
                  )
              ),
          },
        },
        {
          path: 'rackTransfer',
          name: 'ruleCenter.skillManagementRule.operatorSkill.rackTransfer',
          meta: {
            title: 'RT Putaway',
            menuHide: true,
          },
          redirect:
            '/rulecenter/skillManagementRule/operatorSkill/rackTransfer/putaway',
        },
        {
          path: 'rackTransfer/putaway',
          name: 'ruleCenter.skillManagementRule.operatorSkill.rackTransfer.rtPutaway',
          meta: {
            title: 'RT Putaway',
            menuHide: true,
            navList: operatorSkillRackTransferBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'rackTransfer/putaway/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.rackTransfer.rtPutaway.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillRackTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.rackTransfer.rtPutaway',
                title: 'RT Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.rackTransfer.rtPutaway.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/rack-transfer/rt-putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'rackTransfer/putaway/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.rackTransfer.rtPutaway.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillRackTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.rackTransfer.rtPutaway',
                title: 'RT Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.rackTransfer.rtPutaway.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/rack-transfer/rt-putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'rackTransfer/rackTransfer',
          name: 'ruleCenter.skillManagementRule.operatorSkill.rackTransfer.rackTransfer',
          meta: {
            title: 'Rack transfer',
            menuHide: true,
            navList: operatorSkillRackTransferBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'rackTransfer/rackTransfer/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.rackTransfer.rackTransfer.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillRackTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.rackTransfer.rackTransfer',
                title: 'Rack Transfer',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.rackTransfer.rackTransfer.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/rack-transfer/rack-transfer/rackTransferEdit'
                  )
              ),
          },
        },
        {
          path: 'rackTransfer/rackTransfer/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.rackTransfer.rackTransfer.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillRackTransferBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.rackTransfer.rackTransfer',
                title: 'Rack Transfer',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.rackTransfer.rackTransfer.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/rack-transfer/rack-transfer/rackTransferEdit'
                  )
              ),
          },
        },
        {
          path: 'inbound',
          name: 'ruleCenter.skillManagementRule.operatorSkill.inbound',
          meta: {
            title: 'Inbound',
            menuHide: true,
          },
          redirect:
            '/rulecenter/skillManagementRule/operatorSkill/inbound/putaway',
        },
        {
          path: 'inbound/putaway',
          name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.putaway',
          meta: {
            title: 'Putaway',
            menuHide: true,
            navList: operatorSkillInboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'inbound/putaway/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.putaway.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.inbound.putaway',
                title: 'Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.putaway.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/inbound/putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'inbound/putaway/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.putaway.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.inbound.putaway',
                title: 'Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.putaway.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/inbound/putaway/edit'
                  )
              ),
          },
        },

        {
          path: 'inbound/arriving',
          name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.arriving',
          meta: {
            title: 'Arriving',
            menuHide: true,
            navList: operatorSkillInboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'inbound/arriving/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.arriving.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.inbound.arriving',
                title: 'Arriving',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.arriving.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/inbound/arriving/edit'
                  )
              ),
          },
        },
        {
          path: 'inbound/arriving/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.arriving.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.inbound.arriving',
                title: 'Arriving',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.arriving.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/inbound/arriving/edit'
                  )
              ),
          },
        },
        {
          path: 'inbound/boxing',
          name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.boxing',
          meta: {
            title: 'Boxing',
            menuHide: true,
            navList: operatorSkillInboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'inbound/boxing/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.boxing.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.inbound.boxing',
                title: 'Boxing',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.boxing.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/inbound/boxing/edit'
                  )
              ),
          },
        },
        {
          path: 'inbound/boxing/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.boxing.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.inbound.boxing',
                title: 'Boxing',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.boxing.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/inbound/boxing/edit'
                  )
              ),
          },
        },
        {
          path: 'inbound/crossDockSorting',
          name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.crossDockSorting',
          meta: {
            title: 'Cross Dock Sorting',
            menuHide: true,
            navList: operatorSkillInboundBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'inbound/crossDockSorting/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.crossDockSorting.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.inbound.crossDockSorting',
                title: 'Cross Dock Sorting',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.crossDockSorting.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/inbound/cross-dock-sorting/edit'
                  )
              ),
          },
        },
        {
          path: 'inbound/crossDockSorting/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.crossDockSorting.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillInboundBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.inbound.crossDockSorting',
                title: 'Cross Dock Sorting',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.inbound.crossDockSorting.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/inbound/cross-dock-sorting/edit'
                  )
              ),
          },
        },
        {
          path: 'replenishmentReturn',
          name: 'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn',
          meta: {
            title: 'RR Putaway',
            menuHide: true,
          },
          redirect:
            '/rulecenter/skillManagementRule/operatorSkill/replenishmentReturn/rrPutaway',
        },
        {
          path: 'replenishmentReturn/rrPutaway',
          name: 'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn.rrPutaway',
          meta: {
            title: 'RR Putaway',
            menuHide: true,
            navList: operatorSkillReplenishmentReturnBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'replenishmentReturn/rrPutaway/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn.rrPutaway.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillReplenishmentReturnBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn.rrPutaway',
                title: 'RR Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn.rrPutaway.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/replenishment-return/rr-putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'replenishmentReturn/rrPutaway/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn.rrPutaway.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillReplenishmentReturnBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn.rrPutaway',
                title: 'RR Putaway',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn.rrPutaway.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/replenishment-return/rr-putaway/edit'
                  )
              ),
          },
        },
        {
          path: 'replenishmentReturn/replenishmentReturn',
          name: 'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn.replenishmentReturn',
          meta: {
            title: 'Replenishment/Reverse',
            menuHide: true,
            navList: operatorSkillReplenishmentReturnBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'replenishmentReturn/replenishmentReturn/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn.replenishmentReturn.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillReplenishmentReturnBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn.replenishmentReturn',
                title: 'Replenishment/Reverse',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn.replenishmentReturn.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/replenishment-return/replenishment-return/edit'
                  )
              ),
          },
        },
        {
          path: 'replenishmentReturn/replenishmentReturn/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn.replenishmentReturn.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillReplenishmentReturnBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn.replenishmentReturn',
                title: 'Replenishment/Reverse',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.replenishmentReturn.replenishmentReturn.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/replenishment-return/replenishment-return/edit'
                  )
              ),
          },
        },
        {
          path: 'rearrangement',
          name: 'ruleCenter.skillManagementRule.operatorSkill.rearrangement',
          meta: {
            title: 'Rearrangement',
            menuHide: true,
          },
          redirect:
            '/rulecenter/skillManagementRule/operatorSkill/rearrangement/picking',
        },
        {
          path: 'rearrangement/picking',
          name: 'ruleCenter.skillManagementRule.operatorSkill.rearrangement.picking',
          meta: {
            title: 'Picking',
            menuHide: true,
            navList: operatorSkillRearrangementBaseNavList,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
        },
        {
          path: 'rearrangement/picking/create',
          name: 'ruleCenter.skillManagementRule.operatorSkill.rearrangement.picking.create',
          meta: {
            title: 'Create',
            menuHide: true,
            navList: [
              ...operatorSkillRearrangementBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.rearrangement.picking',
                title: 'Picking',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.rearrangement.picking.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/rearrangement/picking/edit'
                  )
              ),
          },
        },
        {
          path: 'rearrangement/picking/edit/:id',
          name: 'ruleCenter.skillManagementRule.operatorSkill.rearrangement.picking.edit',
          meta: {
            title: 'Edit',
            menuHide: true,
            navList: [
              ...operatorSkillRearrangementBaseNavList,
              {
                routeName:
                  'ruleCenter.skillManagementRule.operatorSkill.rearrangement.picking',
                title: 'Picking',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.rearrangement.picking.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/rearrangement/picking/edit'
                  )
              ),
          },
        },
        {
          path: 'forFLDriver',
          name: 'ruleCenter.skillManagementRule.operatorSkill.forFLDriver',
          meta: {
            title: 'For FL Driver',
            menuHide: true,
          },
          component: () =>
            import('@/views/rule-center/operator-skill/tabs.vue'),
          redirect:
            '/rulecenter/skillManagementRule/operatorSkill/forFLDriver/putdown',
          children: [
            {
              path: 'putdown',
              name: 'ruleCenter.skillManagementRule.operatorSkill.forFLDriver.putdown',
              meta: {
                title: 'Putdown',
                menuHide: true,
              },
            },
          ],
        },
        {
          path: 'putdown/detail/:mode(create|edit)/:user_id?',
          name: 'ruleCenter.skillManagementRule.operatorSkill.forFLDriver.putdown.detail',
          meta: {
            title: 'Binding Detail',
            menuHide: true,
            navList: operatorSkillPutdownBaseNavList,
          },
          component: reactContainerFactory({
            name: 'ruleCenter.skillManagementRule.operatorSkill.forFLDriver.putdown.detail',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/operator-skill/for-fl-driver/putdown/form'
                  )
              ),
          },
        },
      ],
    },
  ],
};
